<template>
    <div>
        <b-form acton="#" @submit.prevent="onSubmit" autocomplete="off" class="py-3">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <b-form-select 
                            v-model="form.symbol" 
                            :options="activeSymbols"
                            name="symbol"
                            id="symbol"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- Select Asset --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col>
                        <b-form-select 
                            v-model="form.type" 
                            :options="boostType"
                            name="type"
                            id="type"
                            class="text-center"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- Period --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col class="text-right">
                        <div v-if="buttonLoadingState">
                            <b-button type="submit" variant="primary" :disabled="buttonLoadingState"><b-spinner small type="grow"></b-spinner></b-button>
                        </div>
                        <div v-else>
                            <b-button type="submit" variant="primary">Boost {{ labelOrSymbol }}</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>

    </div>
</template>

<script>

import { mapState } from "vuex";
import apiMixin from '@/mixins/api';

export default {
    name: 'Boosts',
    mixins: [apiMixin],
    props: ['requestUpdate'],
    data() {
        return {
            form: {
                symbol: null,
                type: null,
            },
            boostType: ['7d', '30d', '90d', '1y'],
            buttonLoadingState: false,
        }
    },
    methods: {
        async onSubmit() {
            if (this.buttonLoadingState) return;

            if (!this.form.symbol || !this.form.type) {
                this.popMessage('Invalid selection', 'danger');
                return;
            }

            this.buttonLoadingState = true;

            const response = await this.apiPost('/api/boost/add', {
                symbol: this.form.symbol,
                boost_type: this.form.type,
            });

            this.buttonLoadingState = false;

            if (response?.data?.boost) {
                this.form = { symbol: null, type: null };
                this.popMessage('Asset added to database', 'success');
                this.$emit('update:requestUpdate', true);
            } else if (response) {
                this.popMessage('API error, check view /boost/add', 'danger');
            }
        },
        popMessage(message, variant = 'info') {
            this.$bvToast.toast(message, {
                title: `:(`,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: true,
                variant: variant,
            })
        }
    },
    computed: {
        ...mapState({
            assets: state => state.assets,
        }),
        labelOrSymbol() {
            if (this.form.symbol) return this.form.symbol;
            return 'asset';
        },
        activeSymbols() {
            return this.assets.assetList.filter(asset => asset.status !== 'disabled').map(asset => asset.symbol).sort();
        }
    },
}

</script>